import { render } from "./UserPreviewForList.vue?vue&type=template&id=08098fc7"
import script from "./UserPreviewForList.vue?vue&type=script&lang=js"
export * from "./UserPreviewForList.vue?vue&type=script&lang=js"

import "./UserPreviewForList.vue?vue&type=style&index=0&id=08098fc7&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__